import { render, staticRenderFns } from "./swiper.vue?vue&type=template&id=2245ccc6&scoped=true"
import script from "./swiper.vue?vue&type=script&lang=js"
export * from "./swiper.vue?vue&type=script&lang=js"
import style0 from "./swiper.vue?vue&type=style&index=0&id=2245ccc6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2245ccc6",
  null
  
)

export default component.exports